import { useLazyQuery, useMutation } from '@apollo/client';
import Loader from 'components/Loader';
import Paginate from 'components/Paginate';
import TableError from 'components/TableError';
import {
  DELETE_COMMUNITY_POST,
  DELETE_POST_COMMENT,
  UPDATE_POST_COMMENT,
} from 'containers/community/graphql/community.mutation';
import { GET_COMMUNITY_COMMENTS_LIST } from 'containers/community/graphql/community.query';
import { useRouter } from 'hooks/useRouter';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import confirm from 'reactstrap-confirm';
import { ACTIVE_AND_DELETED_ARRAY } from 'utils/constants';
import { buildURL, checkIfValueExist, createPostDetailsLink, printDate, printSerialNumbers } from 'utils/helper';
import { SMKLinks } from 'utils/links';
import Breadcrumbs from '../../../../../components/Common/Breadcrumb';
import AddCommentModal from './addCommentModal';

const CommentsList = () => {
  const router = useRouter();
  const { query } = router;
  const [commentsList, setCommentsList] = useState([]);
  const [commentsPagination, setCommentsPagination] = useState({});

  const defaultFilters = {
    active: { value: null, label: 'All' },
    deleted: { value: null, label: 'All' },
    // name: '',
  };

  const [isOpenCommentModal, setIsOpenCommentModal] = useState(false);

  const togggleCommentModal = () => {
    setIsOpenCommentModal(!isOpenCommentModal);
  };

  const [filters, setFilters] = useState(defaultFilters);

  const [getCommentsRequest, { loading: commentsRequestLoading }] = useLazyQuery(GET_COMMUNITY_COMMENTS_LIST, {
    onCompleted: (data) => {
      const payload = data?.admin_community_post_comment_search;
      setCommentsList(payload?.results);
      setCommentsPagination(payload?.pagination);
    },
    onError: () => {
      toast.error('Something went wrong!');
    },
  });

  const [markCommentDeleted, { loading: markDeletedLoading }] = useMutation(DELETE_POST_COMMENT, {
    onCompleted: (data) => {
      if (data?.admin_community_post_comment_remove) {
        handleChangePage(parseInt(router?.query?.page, 10) || 1);
        toast.success('Success! Community Post Comment has been deleted ');
      }
    },
    onError: (error) => {
      toast.error('Something went wrong!');
    },
  });
  const [markCommentUndeleted, { loading: markCommentUndeletedLoading }] = useMutation(UPDATE_POST_COMMENT, {
    onCompleted: (data) => {
      if (data?.admin_community_post_comment_update) {
        handleChangePage(parseInt(router?.query?.page, 10) || 1);
        toast.success('Success! Community Post Comment has been updated ');
      }
    },
    onError: (error) => {
      toast.error('Something went wrong!');
    },
  });

  const handleChangePage = (page) => {
    getCommentsRequest({
      variables: {
        searchDTO: {
          page: page ? page : 1,
          size: 20,
          sortBy: 'createdDate',
          sortOrder: 1,
          ...filters,
          active: checkIfValueExist(filters?.active?.value),
          deleted: checkIfValueExist(filters?.deleted?.value),
          //   name: urlSlugify(filters?.name),
        },
      },
    });
  };

  const handleCommentDelete = async (data) => {
    const result = await confirm({
      title: `${data?.deleted ? 'Undelete' : 'Delete'} Group`,
      message: `Are you sure, you want to ${data?.deleted ? 'Undelete' : 'Delete'} this Comment?`,
      confirmText: 'Confirm',
      confirmColor: 'primary',
      cancelColor: 'link text-danger',
    });
    if (result) {
      if (data?.deleted) {
        await markCommentUndeleted({
          variables: {
            commentId: data?.id,
            createDTO: {
              deleted: !data?.deleted,
              active: data?.active,
            },
          },
        });
      } else {
        await markCommentDeleted({
          variables: {
            commentId: data?.id,
          },
        });
      }
    }
  };

  const applyFilters = () => {
    handleChangePage(1);
  };

  const clearFilters = async () => {
    // setFilters({ ...defaultFilters, name: '' });
    setFilters({ ...defaultFilters });
    await getCommentsRequest({
      variables: {
        searchDTO: {
          page: 1,
          size: 20,
          sortBy: 'createdDate',
          sortOrder: 1,
        },
      },
    });
  };

  useEffect(() => {
    handleChangePage();
  }, []);

  return (
    <div className="page-content">
      <Loader isActive={commentsRequestLoading || markDeletedLoading || markCommentUndeletedLoading} />

      <Container fluid>
        <Breadcrumbs title="Community" breadcrumbItem="Community Comments list" />
        <Card>
          <CardBody>
            <div className="mt-4">
              <div className="row">
                <div className="col-lg-2 mb-4">
                  <label className="form-label">Active</label>
                  <Select
                    options={ACTIVE_AND_DELETED_ARRAY}
                    value={filters.active}
                    onChange={(value) => setFilters({ ...filters, active: value })}
                  />
                </div>
                <div className="col-lg-2 mb-4">
                  <label className="form-label">Deleted</label>
                  <Select
                    options={ACTIVE_AND_DELETED_ARRAY}
                    value={filters.deleted}
                    onChange={(value) => setFilters({ ...filters, deleted: value })}
                  />
                </div>

                {/* <div className="col-lg-3 mb-4">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Name..."
                    value={filters.name}
                    onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                  />
                </div> */}
              </div>
            </div>
            <div className="mt-4 pt-2">
              <a className="btn btn-primary me-4" onClick={applyFilters}>
                Apply Filters
              </a>
              <a className="" onClick={clearFilters}>
                Clear
              </a>
            </div>
          </CardBody>
        </Card>

        <Row className="mb-2 mt-4">
          <Col sm="4">
            <div className="search-box me-2 d-inline-block">
              <div className="position-relative font-bold">{commentsPagination?.totalCount || 0} Comments Found</div>
            </div>
          </Col>
          <Col sm="8">
            <div className="text-sm-end">
              <button
                className="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2"
                onClick={togggleCommentModal}>
                <i className="mdi mdi-plus me-1" />
                Add Comment
              </button>
            </div>
          </Col>
        </Row>

        <div className="table-responsive" style={{ minHeight: 300 }}>
          <Table className="project-list-table   table-centered table-borderless">
            <thead>
              <tr className="table-warning">
                <th scope="col">S.No.</th>
                <th scope="col">Comment</th>
                <th scope="col">Post Title</th>
                <th scope="col">Created By</th>
                <th scope="col">Created Date</th>
                <th scope="col">Active</th>
                <th scope="col">Deleted</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(commentsList) ? (
                commentsList?.map((comment, index) => {
                  return (
                    <tr
                      key={`comment_${comment?.id}`}
                      className={!comment?.active || comment?.deleted ? 'bg-danger' : ''}>
                      <td>{printSerialNumbers(commentsPagination)[index]}</td>
                      <td>
                        <div dangerouslySetInnerHTML={{ __html: comment?.content }} />
                      </td>
                      <td>
                        <div className="d-flex">
                          <div>
                            <Link
                              to={buildURL(SMKLinks.COMMUNITY_POST_DETAILS, {
                                id: comment?.post?.id,
                              })}>
                              {comment?.post?.title}
                            </Link>
                          </div>

                          {comment?.post?.id && (
                            <div className="ms-2">
                              <a target="_blank" rel="noreferrer" href={createPostDetailsLink(comment)}>
                                <i className="bx bx-link-external fs-4" />
                              </a>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>{comment?.createdBy?.displayName}</td>
                      <td>{printDate(comment?.createdDate)}</td>
                      <td>
                        <Badge className={comment?.active ? 'bg-success' : 'bg-danger'}>
                          {comment?.active ? 'Yes' : 'No'}
                        </Badge>
                      </td>
                      <td>
                        <Badge className={comment?.deleted ? 'bg-success' : 'bg-danger'}>
                          {comment?.deleted ? 'Yes' : 'No'}
                        </Badge>
                      </td>
                      <td>
                        <UncontrolledDropdown>
                          <DropdownToggle href="#" className="card-drop" tag="i">
                            <i role="button" className="mdi mdi-dots-vertical font-size-18" />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <Link
                              to={buildURL(SMKLinks.COMMUNITY_POSTS_EDIT, {
                                id: comment?.id,
                              })}>
                              <DropdownItem>
                                <i className="fas fa-pencil-alt text-success m-1 pe-3" />
                                Edit
                              </DropdownItem>
                            </Link>

                            <DropdownItem onClick={() => handleCommentDelete(comment)}>
                              <i className={'fas fa-trash-alt text-danger m-1 pe-3'} />
                              {comment?.deleted ? 'Undelete' : 'Delete'}
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <TableError />
              )}
            </tbody>
          </Table>

          {!isEmpty(commentsList) && <Paginate pageInfo={commentsPagination} onChangePage={handleChangePage} />}
        </div>

        <AddCommentModal isOpen={isOpenCommentModal} toggleModal={togggleCommentModal} />
      </Container>
    </div>
  );
};

export default CommentsList;
